import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { getBaseLocation } from '@totvs-apps-components/auth';
import { environment } from './../environments/environment';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';
import { AuthSocialLoginCallbackComponent } from './pages/auth-social-login-callback/auth-social-login-callback.component';
import { BehavioralAssessmentAnswerRedirectComponent } from './pages/behavioral-assessment-answer-redirect/behavioral-assessment-answer-redirect.component';
import { ConfirmEmailVerificationComponent } from './pages/confirm-email-verification/confirm-email-verification.component';
import { EasyApplySuccessComponent } from './pages/easy-apply-success/easy-apply-success.component';
import { JobApplicationRecommendationConfirmationComponent } from './pages/job-application-recommendation-confirmation/job-application-recommendation-confirmation.component';
import { MainComponent } from './pages/main/main.component';
import { OAuthLoginComponent } from './pages/oauth-login/oauth-login.component';
import { PortalRedirectComponent } from './pages/portal/pages/portal-redirect/portal-redirect.component';
import { PortalComponent } from './pages/portal/portal.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { SkillCertAssessmentAnswerRedirectComponent } from './pages/skillcert-assessment-answer-redirect/skillcert-assessment-answer-redirect.component';
import { AcceptProposalLetterComponent } from './pages/job-application-proposal-letter-accept/job-application-proposal-letter-accept.component';

export const ROUTES: Routes = [
  {
    path: 'default',
    component: RedirectComponent,
    children: [{ path: '**', component: RedirectComponent }],
  },
  {
    path: 'feedz',
    component: RedirectComponent,
    children: [{ path: '**', component: RedirectComponent }],
  },
  {
    path: 'oauth/login',
    component: OAuthLoginComponent,
  },
  { path: '', redirectTo: 'register-user', pathMatch: 'full' },
  { path: 'portal', component: PortalComponent },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
  },
  {
    path: 'auth-social-login-callback/:origin',
    component: AuthSocialLoginCallbackComponent,
  },
  {
    path: 'auth-social-login-callback/:origin/:previousRoute',
    component: AuthSocialLoginCallbackComponent,
  },
  {
    path: 'register-user',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'register-user/:previousRoute',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'confirm-email-verification',
    component: ConfirmEmailVerificationComponent,
  },
  {
    path: 'easy-apply',
    loadComponent: () =>
      import('./pages/easy-apply/easy-apply.component').then((c) => c.EasyApplyComponent),
  },
  {
    path: 'main/customizable-test/answer/:id',
    loadComponent: () =>
      import('./pages/customizable-test/customizable-test-answer.component').then(
        (c) => c.CustomizableTestAnswerComponent,
      ),
  },
  {
    path: 'easy-apply/success',
    component: EasyApplySuccessComponent,
  },
  {
    path: 'recommendation-confirmation/:id/accept',
    data: {
      shouldAccept: true,
    },
    component: JobApplicationRecommendationConfirmationComponent,
  },
  {
    path: 'recommendation-confirmation/:id/reject',
    data: {
      shouldAccept: false,
    },
    component: JobApplicationRecommendationConfirmationComponent,
  },
  {
    path: 'accept-offer/:id/:secret',
    component: AcceptProposalLetterComponent,
  },
  {
    // this part of the system is only for logged users
    path: 'main',
    component: MainComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      { path: '', redirectTo: '/home', pathMatch: 'full' },
      {
        path: 'settings',
        loadChildren: () => import('./pages/options/options.module').then((m) => m.OptionsModule),
      },
      {
        path: 'applicant',
        loadChildren: () =>
          import('./pages/applicant/applicant.module').then((m) => m.ApplicantModule),
      },
      {
        path: 'job-opportunity',
        loadChildren: () =>
          import('./pages/job-opportunity/job-opportunity.module').then(
            (m) => m.JobOpportunityModule,
          ),
      },
      {
        path: 'tests',
        loadChildren: () => import('./pages/tests/tests.module').then((m) => m.TestsModule),
      },
      {
        path: 'behavioral-assessment/answer/redirect/:id',
        component: BehavioralAssessmentAnswerRedirectComponent,
      },
      {
        path: 'skill-cert/answer/redirect/:id',
        component: SkillCertAssessmentAnswerRedirectComponent,
      },
      {
        path: 'complementary-form',
        loadChildren: () =>
          import('./pages/complementary-form/complementary-form.module').then(
            (m) => m.ComplementaryFormModule,
          ),
      },
      {
        path: 'portal/job-opportunities',
        component: PortalRedirectComponent,
        resolve: {
          redirect: () => location.replace(environment.jobPortalUrl),
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: getBaseLocation(ROUTES, '') }],
})
export class AppRoutingModule {}
